import { render, staticRenderFns } from "./swPostCard.vue?vue&type=template&id=26aa5066&"
import script from "./swPostCard.vue?vue&type=script&lang=js&"
export * from "./swPostCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports